<template>
  <div>
    <div class="common" v-if="!isRule">
      <div class="tittps" style="font-size: 16px">
        *所有比赛评审的获奖都填在“荣誉获奖”里，其中科研类的获奖，包括论文获奖、课题获奖、案例获奖、课程设计获奖等
      </div>
      <!-- 搜索 -->
      <div class="top clearfix">
        <div class="fl search-form">
          <div class="search-row">
            <div class="search-item">
              <span class="search-label">学年：</span>
              <el-date-picker
                style="width: 150px"
                v-model="searchYear"
                value-format="yyyy"
                size="small"
                type="year"
                @change="selectLsit(1)"
              >
              </el-date-picker>
            </div>
            <div class="search-item">
              <span class="search-label">学期：</span>
              <el-select
                style="width: 150px"
                clearable
                v-model="searchTerm"
                size="small"
                @change="selectLsit(1)"
                placeholder="请选择"
              >
                <template v-for="i of dic.schoolTerm">
                  <el-option
                    :key="i.id"
                    :label="i.dicName"
                    :value="i.dicCode"
                  ></el-option>
                </template>
              </el-select>
            </div>
            <div class="search-item">
              <span class="search-label">获奖类别：</span>
              <el-select
                style="width: 240px"
                size="small"
                clearable
                @change="selectLsit(1)"
                v-model="searchHonorClassify"
                placeholder="请选择"
              >
                <template v-for="i of awardTypeLevelOptions">
                  <el-option
                    :key="i.id"
                    :label="i.dicName"
                    :value="i.dicCode"
                  ></el-option>
                </template>
              </el-select>
            </div>
          </div>
          <div class="search-row">
            <div class="search-item">
              <span class="search-label">获奖级别：</span>
              <el-select
                style="width: 150px"
                size="small"
                clearable
                @change="selectLsit(1)"
                v-model="searchHonorType1"
                placeholder="请选择"
              >
                <template v-for="i of awardTypeOptions">
                  <el-option
                    :key="i.id"
                    :label="i.integralName"
                    :value="i.integralCode"
                  ></el-option>
                </template>
              </el-select>
            </div>
            <div class="search-item">
              <span class="search-label">学部：</span>
              <el-select
                style="width: 150px"
                size="small"
                clearable
                @change="selectLsit(1)"
                v-model="schoolDeptCode"
                placeholder="请选择"
              >
                <template v-for="i of groupOptions">
                  <el-option
                    :key="i.value"
                    :label="i.label"
                    :value="i.value"
                  ></el-option>
                </template>
              </el-select>
            </div>
            <div class="search-item">
              <span class="search-label">获奖日期：</span>
              <el-date-picker
                style="width: 240px"
                size="small"
                value-format="yyyy-MM-dd"
                v-model="searchDate"
                type="daterange"
                align="right"
                unlink-panels
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="selectLsit(1)"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="search-row search-row-buttons">
            <div class="search-item">
              <span class="search-label">搜索：</span>
              <el-input
                style="width: 150px"
                placeholder="请输入关键字"
                v-model="searchKey"
                size="small"
                @change="selectLsit(1)"
                clearable
              >
              </el-input>
            </div>
            <div class="button-group">
              <!-- 批量导入 -->
              <export-upload
                v-if="isAdmin"
                @selectLsit="exSelectLsit"
                :urlAction="exUrl"
                :exData="exData"
              ></export-upload>
              <el-button
                size="small"
                @click="dowTemplate"
                v-if="isAdmin"
              >模板下载</el-button>
              <el-button
                size="small"
                icon="iconfont icon-daochu"
                @click="importTeacher(0)"
                v-if="isAdmin"
                >导出(不含附件)</el-button
              >
              <el-button
                size="small"
                icon="iconfont icon-daochu"
                @click="importTeacher(1)"
                v-if="isAdmin"
                >导出(全部)</el-button
              >
              <el-button size="small" icon="iconfont icon-add" @click="showAddPop"
                >新增</el-button
              >
              <icon-integral-rule
                :isRule="isRule"
                @openRule="isRule = true"
              ></icon-integral-rule>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.9)"
        v-loading="isTableLoading"
        row-key="id"
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#EFEFEF' }"
      >
        <el-table-column prop="schoolYear" label="学年" width="55">
        </el-table-column>
        <el-table-column prop="schoolTermDesc" label="学期" width="80">
        </el-table-column>
        <el-table-column prop="honorDate" label="获奖日期" width="95">
        </el-table-column>
        <el-table-column prop="teacherName" label="获奖教师" width="80">
        </el-table-column>
        <el-table-column prop="schoolDeptName" label="学部" width="70">
        </el-table-column>
        <el-table-column prop="honorType1Desc" label="获奖级别" width="80">
        </el-table-column>
        <el-table-column prop="honorTitle" label="获奖项目"> </el-table-column>
        <el-table-column prop="honorType2Desc" label="获奖等级" width="80">
        </el-table-column>
        <!-- <el-table-column prop="honorClassify" label="获奖类别" width="130">
        </el-table-column> -->
        <el-table-column prop="remark" label="其他获奖等级说明">
        </el-table-column>
        <el-table-column prop="awardingUnit" label="颁奖单位">
        </el-table-column>
        <el-table-column label="附件" width="50">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="
                showImg(
                  scope.row.honorAttaches[0].url,
                  '',
                  scope.row.honorAttaches
                )
              "
              >查看</el-button
            >
          </template>
        </el-table-column>

        <!-- <el-table-column
          prop="score"
          label="获得积分"
        >
        </el-table-column> -->
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              :disabled="isDisabled(scope)"
              type="text"
              class="text-edit"
              @click="showEdit(scope.$index, scope.row)"
              >编辑</el-button
            >|
            <el-button
              :disabled="isDisabled(scope)"
              type="text"
              class="text-del"
              @click="showDelPop(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :pageObj="pageObj"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
      </pagination>

      <!-- 删除的对话框 -->
      <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>

      <!-- 新增的对话框 -->
      <el-dialog
        class="add-pop"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        width="40%"
        top="5%"
      >
        <template v-slot:title>
          <div class="add-title">{{ form.id ? '编 辑' : '新 增' }}</div>
        </template>
        <!-- 对话框内容部分 => 匿名插槽 -->
        <el-form ref="form" :rules="rules" :model="form" label-width="140px">
          <el-form-item label="学年" prop="schoolYear">
            <el-date-picker
              class="width-form-input"
              v-model="form.schoolYear"
              value-format="yyyy"
              type="year"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="学期" prop="schoolTerm">
            <el-select v-model="form.schoolTerm" placeholder="请选择">
              <template v-for="i of dic.schoolTerm">
                <el-option :label="i.dicName" :value="i.dicCode"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <!-- 获奖日期 -->
          <el-form-item label="获奖日期" prop="honorDate">
            <el-date-picker
              class="width-form-input"
              v-model="form.honorDate"
              value-format="yyyy-MM-dd"
              type="month"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 教师姓名 -->
          <el-form-item label="获奖教师" prop="teacherId">
            <el-select
              v-model="form.teacherId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入教师姓名关键字"
              :remote-method="teacherKeyChange"
              :loading="teacherLoading"
            >
              <el-option
                v-for="item in teacherOptions"
                :key="item.id"
                :label="
                  item.teacherNum
                    ? item.userName + '(师训号:' + item.teacherNum + ')'
                    : item.userName
                "
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 学部 -->
          <el-form-item label="学部" prop="schoolDeptCode">
            <el-select v-model="form.schoolDeptCode" placeholder="请选择">
              <template v-for="i of groupOptions">
                <el-option
                  :key="i.id"
                  :label="i.label"
                  :value="i.value"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="获奖项目" prop="honorTitle">
            <el-input v-model="form.honorTitle" placeholder="请输入"></el-input>
          </el-form-item>
          <!-- 获奖类别 -->
          <el-form-item label="获奖类别" prop="honorClassify">
            <el-select v-model="form.honorClassify" placeholder="请选择">
              <template v-for="i of awardTypeLevelOptions">
                <el-option
                  :key="i.id"
                  :label="i.dicName"
                  :value="i.dicCode"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <!-- 获奖级别 -->
          <el-form-item label="获奖级别" prop="honorType1">
            <el-select
              @change="honorType1Change"
              v-model="form.honorType1"
              placeholder="请选择"
            >
              <template v-for="i of awardTypeOptions">
                <el-option
                  :key="i.id"
                  :label="i.integralName"
                  :value="i.integralCode"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="荣誉称号" prop="honorName">
            <el-input v-model="form.honorName" placeholder="请输入"></el-input>
          </el-form-item>-->

          <!-- 获奖等级 -->
          <el-form-item label="获奖等级" prop="honorType2">
            <el-select v-model="form.honorType2" placeholder="请选择">
              <template v-for="i of RuleOption">
                <el-option
                  :key="i.id"
                  :label="i.integralName"
                  :value="i.integralCode"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="其他获奖等级说明" prop="remark">
            <el-input placeholder="请输入" v-model="form.remark"></el-input>
          </el-form-item>
          <el-form-item label="颁奖单位" prop="awardingUnit">
            <el-input
              placeholder="请输入"
              v-model="form.awardingUnit"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传附件" prop="honorAttaches">
            <upload
              :limit="10"
              v-if="addVisible"
              :allowType="1"
              :fileLimit="50"
              :fileList="form.honorAttaches"
              :fileUrl="form.honorAttach"
              @uploadFileUrl="uploadFileUrl"
            >
            </upload>
            <div style="font-size: 12px">
              *证书、公示文件、发表刊物封面、目录及文章首页等
            </div>
          </el-form-item>
        </el-form>

        <template v-slot:footer>
          <span class="dialog-footer">
            <el-button @click="submitStudent" type="primary">提 交</el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 图片预览弹框 -->
      <ViewImg :img-path-list="imgPathList" :is-show.sync="imgVisible" />
    </div>

    <div v-else>
      <integral-rule-view @closeRule="isRule = false"></integral-rule-view>
    </div>
  </div>
</template>

<script>
import IconIntegralRule from '@/components/IconIntegralRule.vue'
import IntegralRuleView from '@/components/IntegralRuleView.vue'
import Pagination from '@/components/Pagination.vue'
import PopupDel from '@/components/PopupDel.vue'
import Upload from '@/components/Upload.vue'
import ViewImg from '@/components/ViewImg.vue'
import ExportUpload from '@/components/ExportUpload.vue'
import { mixin } from '@/mixin/mixin'
import { mapState } from 'vuex'
import { downloadExecl } from '@/utils/index.js'
export default {
  mixins: [mixin],
  components: {
    PopupDel,
    IconIntegralRule,
    IntegralRuleView,
    Upload,
    Pagination,
    ViewImg,
    ExportUpload
  },
  data() {
    return {
      isRule: false,
      isTableLoading: false,
      searchYear: '',
      searchTerm: '',
      searchHonorType1: '',
      searchHonorType2: '',
      searchDate: '',
      schoolDeptCode: '',
      searchHonorClassify: '',
      imgVisible: false,
      imgUrl: '',
      searchKey: '',
      tableData: [],
      RuleOption: [],
      selectRow: null,
      defaultProps: {
        children: 'child',
        label: 'integralName',
        value: 'integralCode'
      },
      delVisible: false,
      addVisible: false,
      awardTypeLevelOptions: [],
      awardTypeOptions: [],
      groupOptions: [
        {
          value: 'XXB',
          label: '小学部'
        },
        {
          value: 'CZB',
          label: '初中部'
        }
      ],
      groupAllOptions: [],
      form: {
        awardingUnit: '',
        schoolYear: '',
        schoolTerm: '',
        honorName: '',
        honorType1: '', //获奖类型
        honorType2: '', //分级
        remark: '',
        ruleList: '',
        score: '',
        honorDate: '',
        teacherId: '',
        honorTitle: '',
        teacherName: '',
        honorAttach: '',
        honorClassify: '',
        schoolDeptCode: '',
        honorAttaches: []
      },
      rules: {
        schoolYear: [
          {
            required: true,
            message: '请选择学年',
            trigger: ['change', 'blur']
          }
        ],
        schoolDeptCode: [
          {
            required: true,
            message: '请选择学部',
            trigger: ['change', 'blur']
          }
        ],
        teacherId: [
          {
            required: true,
            message: '请选择获奖教师',
            trigger: ['change', 'blur']
          }
        ],
        awardingUnit: [
          {
            required: true,
            message: '请输入颁奖单位',
            trigger: ['change', 'blur']
          }
        ],
        teacherName: [
          {
            required: true,
            message: '教师名称不符合规范',
            trigger: ['change', 'blur']
          }
        ],
        honorDate: [
          {
            required: true,
            message: '请选择获奖日期',
            trigger: ['change', 'blur']
          }
        ],
        schoolTerm: [
          {
            required: true,
            message: '请选择学期',
            trigger: ['change', 'blur']
          }
        ],
        honorClassify: [
          {
            required: true,
            message: '请选择获奖级别',
            trigger: ['change', 'blur']
          }
        ],
        honorType1: [
          {
            required: true,
            message: '请选择获奖级别',
            trigger: ['change', 'blur']
          }
        ],
        honorType2: [
          {
            required: true,
            message: '请选择获奖等级',
            trigger: ['change', 'blur']
          }
        ],
        honorTitle: [
          {
            required: true,
            message: '请输入获奖名称',
            trigger: ['change', 'blur']
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: ['change', 'blur']
          }
        ],
        // honorName: [
        //   {
        //     required: true,
        //     message: "请输入荣誉名称",
        //     trigger: ["change", "blur"],
        //   },
        //   {
        //     min: 1,
        //     max: 50,
        //     message: "长度在 1 到 50 个字符",
        //     trigger: ["change", "blur"],
        //   },
        // ],
        honorAttaches: [
          {
            required: true,
            message: '请选择附件',
            trigger: ['change', 'blur']
          }
        ]
      },
      pageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25, 30]
      },
      exUrl: '/imp/importTeacherHonorInfo'
    }
  },
  computed: {
    ...mapState([
      'isAdmin',
      'userInfo',
      'dic',
      'teacherOptions',
      'teacherLoading',
      'ruleOptions',
      'ruleOptionsList'
    ]),
    exData() {
      return {
        schoolCode: this.userInfo.schoolCode,
        menuCode: 'single-prize_ssdt',
        operatorId: this.userInfo.userId
      }
    }
  },
  created() {
    this.searchYear = ''
    this.searchTerm = ''
    // let { menuCode } = this.userInfo.menuInfoList.find(
    //   (item) => this.$route.path.indexOf(item.menuCode) != -1
    // );
    // this.$store.dispatch("getRuleOptions", menuCode); //积分规则下拉列表,获奖分类
    this.selectLsit(1) //首页list
    this.getDicLevelAwards()
    this.getDicAwards()
  },
  mounted() {},
  methods: {
    honorType1Change() {
      this.form.honorType2 = ''
    },

    // 获奖级别字典
    getDicLevelAwards() {
      const paramsDic = {
        clientPackage: 'com.xueduoduo.teacher.archives.pc',
        dicType: 'teacherHonorClassify',
        schoolCode: this.userInfo.schoolCode
      }
      this.$axios
        .get('/dic/listDictionaryByDicType', { params: paramsDic })
        .then((res) => {
          if (res.data.records && res.data.records.length > 0) {
            this.awardTypeLevelOptions = res.data.records
          }
        })
    },
    getChildIntegralRule(parentCode) {
      const paramsDic = {
        integralModel: 'single-prize_ssdt',
        schoolCode: this.userInfo.schoolCode,
        parentCode
      }
      this.$axios
        .post(
          '/integralRule/getChildIntegralRule',
          this.$qs.stringify(paramsDic)
        )
        .then((res) => {
          this.RuleOption = res.data
        })
    },
    // 获奖类型字典
    getDicAwards() {
      const paramsDic = {
        integralModel: 'single-prize_ssdt',
        schoolCode: this.userInfo.schoolCode
      }
      this.$axios
        .post(
          '/integralRule/getTeacherIntegralRule',
          this.$qs.stringify(paramsDic)
        )
        .then((res) => {
          if (res.data && res.data.child.length > 0) {
            this.awardTypeOptions = res.data.child
          }
        })
    },
    //教师选择的列表
    teacherKeyChange(keyword) {
      keyword != '' && this.$store.dispatch('getTeacherOptions', keyword)
    },
    //首页 查询首页list
    selectLsit(curPage, pageSize) {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        clientPackage: 'com.xueduoduo.teacher.archives.pc',
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        schoolTerm: this.searchTerm || '',
        schoolYear: this.searchYear || '',
        keyword: this.searchKey || '',
        schoolDeptCode: this.schoolDeptCode || '',
        honorType1: this.searchHonorType1 || null,
        honorType2: this.searchHonorType2 || null,
        startDate: this.searchDate?.[0] || null,
        endDate: this.searchDate?.[1] || null,
        honorClassify: this.searchHonorClassify || null,
        isAdmin: this.isAdmin / 1,
        operatorId: this.userInfo.userId
      }
      this.isTableLoading = true
      this.$axios
        .post('/teacherHonor/getTeacherHonorInfoList1', homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size
            this.pageObj.current = res.data.current
            this.pageObj.total = res.data.total
            this.tableData = res.data.records
          } else {
            this.$message({
              message: '网络错误',
              type: 'error'
            })
          }
          this.isTableLoading = false
        })
        .catch((err) => {
          console.log('教师error', err)
        })
    },
    //导出
    importTeacher(isAttach = 1) {
      let exportData = {
        schoolCode: this.userInfo.schoolCode,
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        schoolTerm: this.searchTerm,
        schoolYear: this.searchYear,
        honorType1: this.searchHonorType1,
        honorType2: this.searchHonorType2,
        startDate: this.searchDate?.[0],
        endDate: this.searchDate?.[1],
        honorClassify: this.searchHonorClassify,
        isAttach: isAttach
      }
      this.isTableLoading = true
      this.$axios
        .post('/exp/exportTeacherHonorInfoZip', exportData)
        .then((res) => {
          if (res?.data) {
            this.isTableLoading = false
            const download = document.createElement('a')
            download.style.display = 'none'
            download.href = res.data.url
            download.setAttribute('download', res.data.name)
            document.body.appendChild(download)
            download.click()
            document.body.removeChild(download)
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
            this.isTableLoading = false
          }
        })
        .catch(() => {
          this.isTableLoading = false
        })
    },
    // 获得积分
    // getScore(val) {
    //   let find = this.ruleOptions.find((f) => f.integralCode == val);
    //   if (find) {
    //     this.form.score = find.integralNum;
    //   }
    // },
    previewEnclosure() {},
    handleEdit() {},
    //编辑
    showEdit(index, row) {
      this.selectRow = row
      //重置效验样式
      this.$refs.form && this.$refs.form.resetFields()
      //查询教师的选择
      this.teacherKeyChange(row.teacherName)
      this.getChildIntegralRule(row.honorType1)
      this.form = {
        id: row.id,
        awardingUnit: row.awardingUnit,
        schoolYear: row.schoolYear + '',
        schoolTerm: row.schoolTerm + '',
        honorDate: row.honorDate,
        honorType1: row.honorType1,
        honorType2: row.honorType2,
        remark: row.remark,
        honorName: row.honorName,
        score: row.score,
        teacherId: row.teacherId,
        honorTitle: row.honorTitle,
        teacherName: row.teacherName,
        honorAttaches: row.honorAttaches,
        honorAttach: row.honorAttach,
        honorClassify: row.honorClassify,
        schoolDeptCode: this.groupOptions.length > 0 ? row.schoolDeptCode : ''
      }
      //判断 积分规则是否有删除，如果对应的积分已经删除，则 需要重新选择 积分分类
      // this.isInclude(this.ruleOptionsList, this.form.ruleList) ? "" : (this.form.ruleList = []);
      // this.getScore();
      this.addVisible = true
    },
    // 删除
    showDelPop(index, row) {
      this.selectRow = row
      this.delVisible = true
    },
    closePopupDel(status) {
      if (status) {
        console.log('发送删除请求')
        let del = {
          clientPackage: 'com.xueduoduo.teacher.archives.pc',
          id: this.selectRow.id,
          operatorId: this.userInfo.userId
        }
        this.$axios
          .post('/teacherHonor/deleteTeacherHonorInfo', del)
          .then((res) => {
            if (res.resultCode === 200) {
              this.selectLsit(this.pageObj.current, this.pageObj.size),
                this.$message({
                  message: '删除成功',
                  type: 'success',
                  duration: 2000,
                  offset: 150
                })
            } else {
              console.log('del else', res)
            }
          })
          .catch((err) => {
            console.log('del error', err)
          })
        this.delVisible = false
      } else {
        this.delVisible = false
      }
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize
      this.selectLsit(1, pageSize)
    },
    handleCurrentChange(curPage) {
      this.selectLsit(curPage)
    },
    // 新增
    showAddPop() {
      //清空form表单
      this.form = {
        id: '',
        awardingUnit: '',
        schoolYear: '',
        schoolTerm: '',
        honorDate: '',
        honorType1: '',
        honorType2: '',
        remark: '',
        ruleList: '',
        honorName: '',
        score: '',
        teacherId: '',
        honorTitle: '',
        teacherName: '',
        honorAttach: '',
        schoolDeptCode: '',
        honorAttaches: []
      }
      this.$refs.form && this.$refs.form.resetFields()
      this.addVisible = true
    },
    //新增学生获奖  更新
    submitStudent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            //更新
            this.form.operatorId = this.userInfo.userId
            this.form.schoolCode = this.userInfo.schoolCode
            this.$axios
              .post('/teacherHonor/updateTeacherHonorInfo', this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields()
                  this.selectLsit(this.pageObj.current, this.pageObj.size)
                  this.$message({
                    message: '更新成功',
                    type: 'success',
                    duration: 2000,
                    offset: 150
                  })
                } else {
                  console.log('update else', res)
                }
                this.addVisible = false
              })
              .catch((err) => {
                console.log('update error', err)
              })
          } else {
            //保存
            this.form.operatorId = this.userInfo.userId
            this.form.schoolCode = this.userInfo.schoolCode
            this.$axios
              .post('/teacherHonor/saveTeacherHonorInfo', this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  this.$refs.form.resetFields()
                  this.selectLsit(this.pageObj.current, this.pageObj.size)
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    duration: 2000,
                    offset: 150
                  })
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error',
                    duration: 2000,
                    offset: 150
                  })
                }
                this.addVisible = false
              })
          }
        }
      })
    },
    uploadFileUrl(fileUrl, fileList) {
      this.form.honorAttaches = fileList
      this.form.honorAttach = fileUrl
    },
    // 模板下载
    dowTemplate() {
      downloadExecl(
        '/imp/downloadTeacherHonorTemplate',
        '个人荣誉-模板-' + this.userInfo.userName,
        {
          schoolCode: this.userInfo.schoolCode,
          menuCode: 'single-prize_ssdt'
        }
      )
    },
    // 批量导入成功后刷新列表
    exSelectLsit() {
      this.selectLsit(1)
    }
  },
  watch: {
    'form.teacherId'(newValue) {
      if (newValue && this.teacherOptions) {
        let teacherObj = this.teacherOptions.find(
          (item) => item.userId === newValue
        )
        this.form.teacherName = teacherObj && teacherObj.userName
      }
    },
    'form.honorType1'(newValue) {
      if (newValue && this.awardTypeOptions) {
        this.getChildIntegralRule(newValue)
      }
    },
    'form.honorType2'(newValue) {
      if (newValue && this.RuleOption && this.RuleOption.length > 0) {
        let obj = this.RuleOption.find((item) => item.integralCode === newValue)
        this.form.score = obj.integralNum
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../styles/common.less';

.search-form {
  .search-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .search-item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      margin-bottom: 8px;

      .search-label {
        display: inline-block;
        min-width: 70px;
        text-align: right;
        margin-right: 8px;
        font-size: 14px;
        color: #606266;
        white-space: nowrap;
      }
    }

    &.search-row-buttons {
      align-items: center;

      .button-group {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-left: 24px;

        > * {
          margin-right: 10px;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>

